<div class="flex flex-col gap-[16px] justify-start items-start">
  <h3 *ngIf="!isHeaderInside">{{ header }}</h3>

  <div class="container flex flex-col gap-[12px] justify-start items-start">
    <h3 *ngIf="isHeaderInside">{{ header }}</h3>

    <ng-container [ngSwitch]="section">
      <!-- Ecu -->
      <div *ngSwitchCase="activeErrorDetailsSections.Ecu" class="blur-item"></div>

      <!-- SystemBehavior -->
      <div
        *ngSwitchCase="activeErrorDetailsSections.SystemBehavior"
        class="full-width flex flex-col gap-[6px]"
      >
        <div class="blur-item"></div>
        <div class="blur-item"></div>
      </div>

      <!-- Freeze frame -->
      <ng-container *ngSwitchCase="activeErrorDetailsSections.FreezeFrame">
        <app-warning-box
          *ngIf="isFreezeFrameErrorOccurred"
          [isFreezeFrameErrorOccurred]="isFreezeFrameErrorOccurred"
        ></app-warning-box>

        <div class="freeze-frame">
          <ng-container *ngFor="let entry of mockedFreezeFrame; index as index">
            <div class="freeze-frame-item-wrapper" *ngIf="index < 3">
              <div class="freeze-frame-item-long"></div>
              <div class="freeze-frame-item-short"></div>
            </div>
            <!-- Show more data if not mobile -->
            <div class="freeze-frame-item-wrapper lt-lg:!hidden" *ngIf="index > 3">
              <div class="freeze-frame-item-long"></div>
              <div class="freeze-frame-item-short"></div>
            </div>
          </ng-container>
          <!-- Button scrolling to top / pointing to start RD session button -->
          <div class="redirection" *ngIf="isStartDiagnosticsSessionButton">
            <button
              class="error-details-btn"
              mat-raised-button
              color="primary"
              (click)="scrollToTop()"
            >
              {{ '+ACTIVE_ERROR_DETAILS_PAGE.SCROLL_BUTTON' | translate }}
            </button>
          </div>
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="activeErrorDetailsSections.LiveVdd">
        <app-warning-box
          *ngIf="isLiveVddErrorOccurred"
          [isLiveVddErrorOccurred]="isLiveVddErrorOccurred"
        ></app-warning-box>

        <!-- Live VDD desktop -->
        <div class="full-width" *ngIf="(uiService.currentWindowWidth$ | async) >= 1300">
          <div *ngFor="let item of mockedVddDesktop; index as index; last as last">
            <div class="vdd-row-margin flex flex-row gap-[32px] justify-start items-start">
              <div class="blur-item flex-[10%] max-w-[10%]"></div>
              <ng-container *ngIf="index === 0; else otherRows">
                <div class="blur-item flex-[45%] max-w-[45%]"></div>
                <div class="blur-item flex-[45%] max-w-[45%]"></div>
              </ng-container>
              <ng-template #otherRows>
                <div class="flex-[45%] max-w-[45%]">
                  <div class="flex flex-col gap-[6px]">
                    <div class="blur-item"></div>
                    <div class="blur-item"></div>
                  </div>
                </div>
                <div class="flex-[45%] max-w-[45%]">
                  <div class="flex flex-col gap-[6px]">
                    <div class="blur-item"></div>
                    <div class="blur-item"></div>
                  </div>
                </div>
              </ng-template>
            </div>
            <div *ngIf="!last" class="divider"></div>
          </div>
        </div>

        <!-- Live VDD mobile -->
        <div class="full-width" *ngIf="(uiService.currentWindowWidth$ | async) < 1300">
          <div
            *ngFor="
              let item of mockedVddMobile;
              first as first;
              index as index;
              odd as odd;
              even as even;
              last as last
            "
          >
            <div class="vdd-row-margin flex flex-row gap-[32px] justify-start items-start">
              <ng-container *ngIf="even; else leftColumnForOddRow">
                <div class="blur-item flex-[100%] max-w-[50%]"></div>
              </ng-container>
              <ng-template #leftColumnForOddRow>
                <div class="flex-[100%] max-w-[50%]">
                  <div class="flex flex-col gap-[125px]">
                    <div class="blur-item"></div>
                    <div class="blur-item"></div>
                  </div>
                </div>
              </ng-template>
              <ng-container *ngIf="first; else otherRows">
                <div class="blur-item flex-[100%] max-w-[50%]"></div>
              </ng-container>
              <ng-template #otherRows>
                <ng-container *ngIf="odd; else oddRow">
                  <div class="flex-[100%] max-w-[50%]">
                    <div class="flex flex-col gap-[36px]">
                      <div class="flex flex-col gap-[6px]">
                        <div class="blur-item"></div>
                        <div class="blur-item"></div>
                        <div class="blur-item"></div>
                        <div class="blur-item"></div>
                      </div>
                      <div class="blur-item"></div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #oddRow>
                  <div class="flex-[100%] max-w-[50%]">
                    <div class="flex flex-col gap-[6px]">
                      <div class="blur-item"></div>
                      <div class="blur-item"></div>
                    </div>
                  </div>
                </ng-template>
              </ng-template>
            </div>
            <div *ngIf="!last" class="divider"></div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
